import { OPTIONS } from './types';
import Logger from '../../../common/logger';
import store from '../store';

export const debug = enable => {
    if (enable) {
        Logger.enable();
        store.dispatch({
            type: OPTIONS.DEBUG_ON
        });
    } else {
        Logger.disable();
        store.dispatch({
            type: OPTIONS.DEBUG_OFF
        });
    }
};
